//개인정보처리방침
const personalInfoLink =
  "https://codime.notion.site/2940d0b43f6b80fd92bfc58dbf84837c?source=copy_link";
//서비스이용약관
const serviceLink =
  "https://codime.notion.site/Brand-2940d0b43f6b8020b950cea2c0644974?source=copy_link";

export { personalInfoLink, serviceLink };
